module.exports = __webpack_public_path__ + "static/media/AngolaDetailedMap_KeyBlurred_WebSafe.4f419312.jpg";